export const camelCaseToTitle = (camelCase: string) => {
  // Split the camelCase string at each uppercase letter and join with a space
  const words = camelCase.replace(/([A-Z])/g, " $1");
  // Capitalize the first letter of the resulting string
  return words.charAt(0).toUpperCase() + words.slice(1);
};
